module.exports = __webpack_public_path__ + "img/01.615d9e75.jpg";